import Vue from 'vue';

// 공통 얼럿 이벤트 버스 (싱글톤)
export const alertBus = new Vue();

// 사용법: this.$alert('메시지')  → 확인 클릭 시 resolve 되는 Promise 반환
export default {
  install(VueCtor) {
    VueCtor.prototype.$alert = function (message) {
      const text = message == null ? '' : String(message);
      return new Promise((resolve) => {
        alertBus.$emit('hearing-alert:open', { message: text, resolve });
      });
    };
  },
};
